import { Flex } from "@chakra-ui/layout";

function Content({ children }: { children: any }) {
  return (
    <Flex 
      flex="1"
      bg="#fff"
      minH="100vh"
      marginLeft={81}
      sx={{
        "@media print": {
          marginLeft: 0,
        },
      }}
      >
      {children}
    </Flex>
  );
}

export default Content;
